import "./add-comment.css";
import { useState } from "react";
import { toast } from "react-toastify";
import commentImg from "../../../src/images/comments/comment-bg.jpg";
import { useDispatch } from "react-redux";
import { createComment } from "../../redux/apiCalls/commentApiCalls";

const AddComment = ({ doctorId }) => {
  const dispatch = useDispatch();

  const [text, setText] = useState("");

  const addCommentHandler = (e) => {
    e.preventDefault();
    if (text.trim() === "") {
      return toast.warning("لم يتم اضافة تعليق ..");
    }
    dispatch(createComment({ text, doctorId }));
    setText("");
  };
  return (
    <div className="add-comment-wrapper">
      <div className="comment-form">
        <span>اضف تعليق</span>
        <form onSubmit={addCommentHandler} className="add-comment">
          <input
            value={text}
            type="text"
            placeholder="اكتب تعليق"
            onChange={(e) => setText(e.target.value)}
          />
          <button type="submit"> تعليق </button>
        </form>
      </div>
      <img src={commentImg} alt="commentImg" />
    </div>
  );
};

export default AddComment;
